var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._l(_vm.api_errors, function(error) {
        return _vm.api_errors.length > 0
          ? _c(
              "div",
              { key: error.message, staticClass: "mb-2" },
              [
                _c(
                  "vs-alert",
                  { attrs: { color: "danger", icon: "new_releases" } },
                  [_c("small", [_vm._v(_vm._s(error))])]
                )
              ],
              1
            )
          : _vm._e()
      }),
      _vm._v(" "),
      _c("vue-simple-suggest", {
        ref: "suggestComponent",
        attrs: {
          pattern: "\\w+",
          list: _vm.getList,
          "max-suggestions": 10,
          "min-length": 1,
          debounce: 500,
          "filter-by-query": false,
          "prevent-submit": true,
          controls: {
            selectionUp: [38, 33],
            selectionDown: [40, 34],
            select: [13, 36],
            hideList: [27, 35]
          },
          mode: _vm.mode,
          "nullable-select": true,
          placeholder: "Search Location",
          "value-attribute": "postal_code",
          "display-attribute": "postal_code"
        },
        on: { select: _vm.onSuggestSelect },
        scopedSlots: _vm._u(
          [
            {
              key: "misc-item-above",
              fn: function(ref) {
                var suggestions = ref.suggestions
                var query = ref.query
                return [
                  !_vm.loading && suggestions.length == 0
                    ? _c("div", { staticClass: "misc-item" }, [
                        _c("span", [_vm._v("No results")])
                      ])
                    : _vm._e()
                ]
              }
            },
            {
              key: "suggestion-item",
              fn: function(scope) {
                return _c("div", { attrs: { title: scope.suggestion.code } }, [
                  _c("div", { staticClass: "vx-row" }, [
                    _c("div", { staticClass: "vx-col sm:w-5/6" }, [
                      _c("p", {
                        domProps: {
                          innerHTML: _vm._s(_vm.boldenSuggestion(scope))
                        }
                      })
                    ])
                  ])
                ])
              }
            },
            {
              key: "misc-item-below",
              fn: function(ref) {
                var suggestions = ref.suggestions
                return _vm.loading
                  ? _c("div", { staticClass: "misc-item" }, [
                      _c("span", [_vm._v("Loading...")])
                    ])
                  : _vm._e()
              }
            }
          ],
          null,
          true
        ),
        model: {
          value: _vm.location_model,
          callback: function($$v) {
            _vm.location_model = $$v
          },
          expression: "location_model"
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "vx-row mt-2" }, [
        _c(
          "div",
          { staticClass: "vx-col w-full lg:w-1/3 mb-2" },
          [
            _c("small", { staticClass: "mt-2 w-full" }, [_vm._v("Province")]),
            _vm._v(" "),
            _c("vs-input", {
              staticClass: "w-full",
              attrs: { readonly: true, placeholder: "Province" },
              model: {
                value: _vm.province_model,
                callback: function($$v) {
                  _vm.province_model = $$v
                },
                expression: "province_model"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "vx-col w-full lg:w-1/3 mb-2" },
          [
            _c("small", { staticClass: "mt-2 w-full" }, [_vm._v("City")]),
            _vm._v(" "),
            _c("vs-input", {
              staticClass: "w-full",
              attrs: { readonly: true, placeholder: "State" },
              model: {
                value: _vm.city_model,
                callback: function($$v) {
                  _vm.city_model = $$v
                },
                expression: "city_model"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "vx-col w-full lg:w-1/3 mb-2" },
          [
            _c("small", { staticClass: "mt-2 w-full" }, [_vm._v("District")]),
            _vm._v(" "),
            _c("vs-input", {
              staticClass: "w-full",
              attrs: { readonly: true, placeholder: "district" },
              model: {
                value: _vm.district_model,
                callback: function($$v) {
                  _vm.district_model = $$v
                },
                expression: "district_model"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "vx-col w-full lg:w-1/3 mb-2" },
          [
            _c("small", { staticClass: "mt-2 w-full" }, [
              _vm._v("Subdistrict")
            ]),
            _vm._v(" "),
            _c("vs-input", {
              staticClass: "w-full",
              attrs: { readonly: true, placeholder: "subdistrict" },
              model: {
                value: _vm.subdistrict_model,
                callback: function($$v) {
                  _vm.subdistrict_model = $$v
                },
                expression: "subdistrict_model"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "vx-col w-full lg:w-1/3 mb-2" },
          [
            _c("small", { staticClass: "mt-2 w-full" }, [
              _vm._v("Postal Code")
            ]),
            _vm._v(" "),
            _c("vs-input", {
              staticClass: "w-full",
              attrs: { readonly: true, placeholder: "Postal Code" },
              model: {
                value: _vm.postal_code_model,
                callback: function($$v) {
                  _vm.postal_code_model = $$v
                },
                expression: "postal_code_model"
              }
            })
          ],
          1
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }